module.exports = __webpack_public_path__ + "img/help13.e21da2a5.png";